import React from "react";
import { useTranslation } from "react-i18next";

import { project } from "@planzone/dto";
import { ResourcesList } from "./resourcesList";
import { Props } from "./types";
import styles from "./styles.scss";

function GroupCreationForm(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.groupCreationForm}>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("addResourceGroup.form.title")}</h3>
        <input
          className={styles.input}
          value={props.formData.name}
          placeholder={t("addResourceGroup.form.namePlaceholder")}
          onChange={(e) =>
            props.editForm({
              ...props.formData,
              name: e.target.value,
            })
          }
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>
          {t("addResourceGroup.form.titleDescription")}
        </h3>
        <textarea
          className={styles.textArea}
          placeholder={""}
          value={props.formData.description || ""}
          onChange={({ target }) =>
            props.editForm({
              ...props.formData,
              description: target.value,
            })
          }
        />
      </div>
      <div className={styles.group}>
        <ResourcesList
          resources={props.formData.resources}
          addResources={(resources) =>
            props.editForm({
              ...props.formData,
              resources: [...props.formData.resources, ...resources],
            })
          }
          removeResources={(resources) =>
            props.editForm({
              ...props.formData,
              resources: props.formData.resources.filter(
                (resource) =>
                  !resources.find(({ uuid }) => resource.uuid === uuid),
              ),
            })
          }
        />
      </div>
    </div>
  );
}

export { GroupCreationForm };
